import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { StatusChange } from "@common/models";
import { AuthenticationService } from "@common/services";
import { InsightsService } from "@core/services";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "environments/environment";

@Component({
    selector: "app-ryd-formulas-approval-list-modal",
    templateUrl: "./approval-list-modal.component.html",
    styleUrls: ["./approval-list-modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ApprovalListModalComponent implements OnInit {

  // Subtítulo: nombre del objeto (o "estado - nombre"); el título va traducido
  @Input() title: any;
  @Input() menuId: Number;
  @Input() objectId: Number;
  @Input() statusChange: StatusChange;

  constructor(
    public activeModal: NgbActiveModal,
    private _insightsService: InsightsService,
    private _authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.log('Abrió el historial de aprobaciones', this.logData());
  }

  /**
   * Cierra el modal (X y botón Cerrar)
   */
  close(): void {
    this.log('Cerró el historial de aprobaciones', this.logData());
    this.activeModal.close('Cross click');
  }

  /**
   * Contexto para las trazas: ids, no el historial
   */
  private logData(): any {
    return {
      menuId: this.menuId ?? null,
      objectId: this.objectId ?? null,
      newStatus: this.statusChange?.newStatus?.code ?? null,
    };
  }

  /**
   * Manda una traza a Application Insights, etiquetada con el proyecto y el
   * usuario que la originó.
   */
  private log(message: string, data: any, ex: any = null, error: boolean = false): void {
    const user = this._authenticationService.currentUserValue;

    if (error) {
      this._insightsService.traceError(environment.projects.StatusChange, message, data, ex, user);
      return;
    }

    this._insightsService.traceInfo(environment.projects.StatusChange, message, data, user);
  }
}
